import { AuthMethod } from '~/features/Authorization/enums'

export const PHONE_LENGTH = 11
export const PHONE_EDIT_ATTEMPTS = 1
export const SAVED_AUTH_STATE_KEY = 'auth_state'
export const SAVE_AUTH_TIME_IN_DAYS = 2 / 24

export const MAX_METHOD_ATTEMPTS: Record<AuthMethod, number> = {
  [AuthMethod.Mt]: 2,
  [AuthMethod.Tg]: 1,
  [AuthMethod.Vk]: 2,
  [AuthMethod.Call]: 2,
  [AuthMethod.CallCode]: 2,
  [AuthMethod.OutgoingCall]: 2,
  [AuthMethod.WhatsApp]: 1,
  [AuthMethod.Max]: 1,
  [AuthMethod.WbId]: Infinity, // Нет лимита на OAuth методы
  [AuthMethod.MobileId]: 1,
  [AuthMethod.VkId]: Infinity,
  [AuthMethod.YandexId]: Infinity,
}

export const OAUTH_PAGES_NAMES = ['wb-id-login', 'oauth-external-login']
